/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import {RECEIVED_CONVERSION_HISTORY} from 'state/conversionHistory/ConversionHistoryActions';

export const conversionHistoryInitialState = [];

export const conversionHistoryReducer = (
  state = conversionHistoryInitialState,
  action
) => {
  if (action.type === RECEIVED_CONVERSION_HISTORY) {
    return action.conversionHistory;
  }
  return state;
};
